import { supabase } from '../lib/supabase';
import { logError } from '../utils/logger';

export const createCalendarEvent = (booking) => {
  return supabase.functions.invoke('google-calendar', { body: { action: 'create', booking } })
    .then(({ data, error }) => {
      if (error) logError(supabase, 'calendar', `Calendar create failed: ${error.message}`, { booking_id: booking.id });
      return data;
    });
};

export const updateCalendarEvent = (booking, eventId) => {
  supabase.functions.invoke('google-calendar', {
    body: { action: 'update', booking, calendar_event_id: eventId },
  }).then(({ error }) => {
    if (error) logError(supabase, 'calendar', `Calendar update failed: ${error.message}`, { booking_id: booking.id });
  });
};

export const deleteCalendarEvent = (eventId, bookingId) => {
  supabase.functions.invoke('google-calendar', {
    body: { action: 'delete', calendar_event_id: eventId },
  }).then(({ error }) => {
    if (error) logError(supabase, 'calendar', `Calendar delete failed: ${error.message}`, { booking_id: bookingId });
  });
};

export const setCalendarEventId = async (bookingId, eventId) => {
  await supabase.from('bookings').update({ calendar_event_id: eventId }).eq('id', bookingId);
};
